import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "NavWidget" */ './NavWidget'),
  modules: ['./NavWidget'],
  loading: () => <div style={{ height: '42px' }} />
});

export default LoadableWidget;
